// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_2ZGvRYjBSpv6LB8ZgGgUzC"};